export default __webpack_public_path__ + "static/Infocards_Hover-d2de2da7e6e806622d93d9cf42e8feb1.png";